import ReactDOM from 'react-dom';
import React, { memo, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { enableBodyScroll, disableBodyScroll } from '../../../helpers/body-helper';
import { SSR } from '../../../helpers/ssr';
import * as Styled from './Style';
import Header from './Header';
import fetchDOMDocument from '../../../api/fetchDOMDocument';
import Loader from '../Loader';
import useUpdateEffect from '../../hooks/useUpdateEffect';
const getTitleFromSelector = (document1, selector) => {
  const elem = document1.querySelector(selector);
  if (!elem) {
    return '';
  }
  const title = elem.innerText;
  // IE fix
  elem.parentNode.removeChild(elem);
  return title;
};
const FetchingModal = ({
  url = '',
  errorText = '',
  title = '',
  subtitle = '',
  textContent = null,
  dynamicTitleSelector = null,
  isClosable = true,
  isEnabledScroll = false,
  isOpen = false,
  isSmall = false,
  onClose = Function.prototype,
  onModalClick = Function.prototype,
  closeOutsideClick = true
}) => {
  const contentRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isShown, setIsShown] = useState(isOpen);
  const [content, setContent] = useState(textContent);
  const [dynamicTitle, setTitle] = useState(dynamicTitleSelector && title);
  useEffect(() => {
    setContent(textContent);
  }, [textContent]);
  useUpdateEffect(() => {
    if (!isEnabledScroll) {
      if (isOpen) {
        disableBodyScroll();
      } else {
        enableBodyScroll();
      }
    }
  }, [isOpen]);
  const handleOutsideClose = e => {
    if (contentRef && contentRef.current && !contentRef.current.contains(e.target) && closeOutsideClick) {
      e.preventDefault();
      onClose();
    }
  };
  const requestContent = async () => {
    if (!SSR && url) {
      try {
        setIsLoading(true);
        const document1 = await fetchDOMDocument(url);
        setIsLoading(false);
        if (document1) {
          if (dynamicTitleSelector) {
            setTitle(getTitleFromSelector(document1, dynamicTitleSelector));
          }
          setContent(/*#__PURE__*/React.createElement("div", {
            dangerouslySetInnerHTML: {
              __html: document1.innerHTML
            }
          }));
        } else {
          setContent(/*#__PURE__*/React.createElement("div", {
            dangerouslySetInnerHTML: {
              __html: errorText
            }
          }));
        }
      } catch (e) {
        console.error(e);
        setContent(/*#__PURE__*/React.createElement("div", {
          dangerouslySetInnerHTML: {
            __html: errorText
          }
        }));
      }
    }
    if (!isEnabledScroll) {
      disableBodyScroll();
    }
  };
  useEffect(() => {
    if (isOpen) {
      requestContent();
      setIsShown(true);
    }
  }, [isOpen]);
  return SSR || /*#__PURE__*/ReactDOM.createPortal(/*#__PURE__*/React.createElement(Styled.Root, {
    isOpen: isOpen,
    isShown: isShown,
    isLoading: isLoading,
    onClick: handleOutsideClose
  }, /*#__PURE__*/React.createElement(Styled.Dialog, {
    ref: contentRef,
    isSmall: isSmall
  }, /*#__PURE__*/React.createElement(Styled.Content, {
    onClick: onModalClick
  }, isLoading && /*#__PURE__*/React.createElement(Loader, {
    loaderSize: 48,
    borderSize: 4
  }), !isLoading && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Header, {
    title: dynamicTitle || title,
    subtitle: subtitle,
    isClosable: isClosable,
    onCrossClick: onClose
  }), /*#__PURE__*/React.createElement(Styled.Body, null, content))))), document.body);
};
FetchingModal.propTypes = {
  url: PropTypes.string,
  errorText: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  dynamicTitleSelector: PropTypes.string,
  textContent: PropTypes.node,
  isClosable: PropTypes.bool,
  isEnabledScroll: PropTypes.bool,
  isOpen: PropTypes.bool,
  isSmall: PropTypes.bool,
  onClose: PropTypes.func,
  onModalClick: PropTypes.func,
  closeOutsideClick: PropTypes.bool
};
export default /*#__PURE__*/memo(FetchingModal);